import React from 'react';
import './App.css';
import { useScrollReveal } from './hooks/useScrollReveal';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import StatsStrip from './components/StatsStrip';
import About from './components/About';
import Services from './components/Services';
import WhyChooseStratX from './components/WhyChooseStratX';
import StratXMethod from './components/StratXMethod';
import CaseStudies from './components/CaseStudies';
import Results from './components/Results';
import ClientChallenges from './components/ClientChallenges';
import Founder from './components/Founder';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  useScrollReveal();

  return (
    <div className="App">
      <Navigation />
      <Hero />
      <StatsStrip />
      <About />
      <Services />
      <WhyChooseStratX />
      <StratXMethod />
      <CaseStudies />
      <Results />
      <ClientChallenges />
      <Founder />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
